import React from "react"

// Facebook Logo Component
export const FacebookLogo: React.FC<{ width?: string; height?: string }> = ({
  width = "37",
  height = "37",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      aria-label="Facebook logo"
    >
      <path
        fill="#FFFFFF"
        d="M16.671 24v-9.294h3.131l.446-3.622h-3.577V8.887c0-.995.276-1.675 1.708-1.675h1.825V4.132c-.314-.042-1.397-.135-2.657-.135-2.629 0-4.429 1.606-4.429 4.552v2.548H9.847v3.622h2.973V24h3.851z"
      />
    </svg>
  )
}

// Instagram Logo Component
export const InstagramLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width="39"
      height="39"
      fill="currentColor"
    >
      <path d="M349.33 69.33H162.67C114.51 69.33 76 107.85 76 156v196c0 48.15 38.51 86.67 86.67 86.67h186.66c48.15 0 86.67-38.52 86.67-86.67V156c0-48.15-38.52-86.67-86.67-86.67zm45.34 282.67c0 25-20.33 45.33-45.33 45.33H162.67c-25 0-45.33-20.33-45.33-45.33V156c0-25 20.33-45.33 45.33-45.33h186.66c25 0 45.33 20.33 45.33 45.33v196z" />
      <path d="M256 164c-50.44 0-92 41.56-92 92s41.56 92 92 92 92-41.56 92-92-41.56-92-92-92zm0 152c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60z" />
      <circle cx="352" cy="160" r="16" />
    </svg>
  )
}

export default InstagramLogo

// YouTube Logo Component
export const YouTubeLogo: React.FC<{ width?: string; height?: string }> = ({
  width = "37",
  height = "37",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={width}
      height={height}
      aria-label="YouTube logo"
    >
      <path
        fill="white"
        d="M43.8 13.4C43.4 11.6 42 10.1 40.3 9.7 36.6 8.6 24 8.6 24 8.6s-12.6 0-16.3 1.1C6 10.1 4.6 11.6 4.2 13.4 3.1 17.2 3.1 24 3.1 24s0 6.8 1.1 10.6c.4 1.8 1.8 3.3 3.6 3.7 3.7 1.1 16.3 1.1 16.3 1.1s12.6 0 16.3-1.1c1.7-.4 3.2-1.9 3.6-3.7 1.1-3.8 1.1-10.6 1.1-10.6s0-6.8-1.1-10.6z"
      />
      <path
        fill="#343f4b" // footer color
        d="M20 31V17l12 7z"
      />
    </svg>
  )
}

export const CopyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 5C7 3.34315 8.34315 2 10 2H19C20.6569 2 22 3.34315 22 5V14C22 15.6569 20.6569 17 19 17H17V19C17 20.6569 15.6569 22 14 22H5C3.34315 22 2 20.6569 2 19V10C2 8.34315 3.34315 7 5 7H7V5ZM9 7H14C15.6569 7 17 8.34315 17 10V15H19C19.5523 15 20 14.5523 20 14V5C20 4.44772 19.5523 4 19 4H10C9.44772 4 9 4.44772 9 5V7ZM5 9C4.44772 9 4 9.44772 4 10V19C4 19.5523 4.44772 20 5 20H14C14.5523 20 15 19.5523 15 19V10C15 9.44772 14.5523 9 14 9H5Z"
        fill="gray"
      ></path>
    </svg>
  )
}

export const BarIcon = () => {
  return (
    <svg
      fill="currentColor"
      aria-hidden="true"
      data-icon="bars"
      data-prefix="fas"
      viewBox="0 0 448 512"
    >
      <path
        fill="currentColor"
        d="M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
      ></path>
    </svg>
  )
}

export const CloseIcon = () => {
  return (
    <svg
      fill="currentColor"
      aria-hidden="true"
      data-icon="xmark"
      data-prefix="fas"
      viewBox="0 0 320 512"
    >
      <path
        fill="currentColor"
        d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256l105.3-105.4z"
      ></path>
    </svg>
  )
}

export const ChevronIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="gray"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M9 18l6-6-6-6"></path>
    </svg>
  )
}

export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect
        x="5"
        y="11"
        width="14"
        height="10"
        rx="2"
        ry="2"
        fill="currentColor"
      ></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      <line x1="12" y1="16" x2="12" y2="16"></line>
    </svg>
  )
}

interface IconProps {
  id: number
  open: number
}

export const Icon = ({ id, open }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        id === open ? "rotate-180" : ""
      } h-7 w-7 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="#fbbd69"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  )
}

interface BulletProps {
  size?: number // Size of the circle (default: 8px)
  color?: string // Color of the circle (default: gray)
}

export const Bullet: React.FC<BulletProps> = ({ size = 8, color = "gray" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" />
    </svg>
  )
}
